module.exports = ".alert-stack{display:flex;flex-direction:column}";